import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect } from 'react';
import { useMessageBus } from './useMessageBus';
import { useCrmMessagingContext } from './CrmMessagingContext';
import { isCommandTopic } from './isCommandTopic';
import { throwCommandError } from './internal/throwCommandError';
import { useRegisterSender } from './MessageBusSpyContext';
export function useSendCrmMessageTopic(topic) {
  const $ = _c(10);
  const messageBus = useMessageBus();
  const messagingContext = useCrmMessagingContext();
  const registerSender = useRegisterSender();
  let t0;
  let t1;
  if ($[0] !== messageBus || $[1] !== messagingContext || $[2] !== registerSender || $[3] !== topic) {
    t0 = () => {
      if (isCommandTopic(topic) && !messageBus) {
        throwCommandError(`MessageBusError: The ${topic} command could not be sent because useSendCrmMessageTopic has no messageBus context.`);
      } else {
        if (isCommandTopic(topic) && messageBus) {
          messageBus.registerCommandSender(topic, messagingContext);
        }
      }
      registerSender === null || registerSender === void 0 || registerSender(topic);
    };
    t1 = [messageBus, topic, messagingContext, registerSender];
    $[0] = messageBus;
    $[1] = messagingContext;
    $[2] = registerSender;
    $[3] = topic;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  const messageContextId = messagingContext === null || messagingContext === void 0 ? void 0 : messagingContext.messagingId;
  let t2;
  if ($[6] !== messageBus || $[7] !== messageContextId || $[8] !== topic) {
    t2 = (data, t3) => {
      const config = t3 === undefined ? {} : t3;
      if (!messageBus) {
        return;
      }
      let enveloperSourceId;
      if (config.sourceId) {
        enveloperSourceId = config.sourceId;
      } else {
        if (messageContextId) {
          enveloperSourceId = messageContextId;
        }
      }
      const envelope = {
        sourceId: enveloperSourceId,
        targetId: config.targetId
      };
      const envelopeData = {
        envelope,
        data
      };
      messageBus.publish(topic, envelopeData);
    };
    $[6] = messageBus;
    $[7] = messageContextId;
    $[8] = topic;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}